export default __webpack_public_path__ + "static/book-757b9daae5226b87b68782fd61f2b41b.png";